module.exports = __webpack_public_path__ + "static/media/logo_hyponav_pro_white.e13bccac.svg";